import { render, staticRenderFns } from "./CreatePersona.vue?vue&type=template&id=8a549cc8"
import script from "./CreatePersona.vue?vue&type=script&lang=js"
export * from "./CreatePersona.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports